import { useSelector } from 'react-redux';

import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectIntegrationId } from '@/redux/session/selectors';
import { IntercomIntegration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import { ConnectionInfoCard } from './ConnectionInfoCard';
import { WelcomeTriggerCard } from './WelcomeTriggerCard';
import IntegrationConfigWrapper from '../Components/Integration';

const IntercomSettings = () => {
  const deskId = useDeskId();
  const integrationId = useSelector(selectIntegrationId);

  const { integration } = useIntegrations<IntercomIntegration>(deskId, integrationId);
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );

  if (!integration) {
    return null;
  }

  return (
    <IntegrationConfigWrapper integration={integration}>
      <ConnectionInfoCard integration={integration} />
      <WelcomeTriggerCard integration={integration} canWrite={canWrite} />
    </IntegrationConfigWrapper>
  );
};

export default IntercomSettings;
